module.exports = __webpack_public_path__ + "img/组 126(1).b9308616.png";